import React, { FunctionComponent, useEffect } from 'react';

import { TwBannerComponent, TwMobileBannerComponent } from './banners';
import { TwModalComponent } from './modals';
import { AnnouncementStorageKeys } from './constants';
import { useLocalStorage } from '@mantine/hooks';
import useMobile from 'src/shared/hooks/use-mobile';

export const TwAnnouncementComponent: FunctionComponent = () => {
    const [modalSeen] = useLocalStorage({
        key: AnnouncementStorageKeys.modal,
        defaultValue: false,
    });

    const mobile = useMobile();

    useEffect(() => {
        if (!modalSeen && !mobile) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
            document.body.style.overflowX = 'hidden';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [modalSeen, mobile]);

    return (
        <>
            <TwBannerComponent />
            <TwModalComponent />
            <TwMobileBannerComponent />
        </>
    );
};
